<div class="container">
  @if (to.eicon) {
    <span><fa-icon [icon]="to.eicon"></fa-icon></span>
  }
  {{ to.testun | translate }}
</div>